import { FaWallet, FaLightbulb, FaThumbsUp } from "react-icons/fa";
import { RiCustomerService2Line } from "react-icons/ri";
import { BsShieldCheck } from "react-icons/bs";
import { RiSearchEyeLine } from "react-icons/ri";
import ServiceBox from "src/components/atoms/ServiceBox";

const services = [
  { icon: <BsShieldCheck size={42}/>, label: "Jaminan\nGaransi" },
  { icon: <FaWallet size={42}/>, label: "Budget\nFleksibel" },
  { icon: <FaLightbulb size={42}/>, label: "Solusi\nLengkap" },
  { icon: <FaThumbsUp size={42}/>, label: "Reputasi\nTerpercaya" },
  { icon: <RiCustomerService2Line size={42}/>, label: "Respon\nCepat" },
  { icon: <RiSearchEyeLine size={42}/>, label: "Presale\nPreview" },
];

export default function ServiceList() {
  return (
    <main className="flex items-start justify-center bg-gray-100 mb-16">
      <section className="bg-[#073737] text-white pt-16 pb-8 px-6 md:px-12 w-full">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div data-aos="fade-right" data-aos-duration="1000" data-aos-easing="ease-in-out">
            <h1 className="text-3xl md:text-4xl font-bold mb-6">
              Layanan <span className="text-[#23bb86]">Purna Jual</span>
            </h1> 
            <p className="text-gray-200 leading-relaxed mb-4">
              PT Angkasa Multimedia Solusi memberikan layanan purna jual terpercaya
              dengan garansi resmi untuk setiap pemasangan dan produk. Garansi ini
              mencakup perlindungan dari kerusakan maupun kendala teknis, yang
              ditangani oleh tim teknisi berpengalaman.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8">
            {services.map((s, i) => (
              <div
                key={i}
                className="flex flex-col items-center text-center"
                data-aos="fade-up"
                data-aos-duration="800"
                data-aos-easing="ease-in-out"
                data-aos-delay={i * 150}
              >
                <ServiceBox icon={s.icon} size="md" />
                <p className="mt-6 text-sm font-medium whitespace-pre-line text-center leading-tight">
                  {s.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
